import React, { ReactNode } from 'react';
import { IWprControlProps } from '../props/IWprControlProps';
import { WprBaseControlComponent } from './WprBaseControlComponent';
import { WprControlVisibility } from '../props/IWprControlState';

/**
 * リストアイテムコントロールプロパティ情報
 */
interface IWprLiProps extends IWprControlProps {
}

/**
 * リストアイテムコントロール
 */
export class WprLi extends WprBaseControlComponent<IWprLiProps, HTMLElement> {
	// プロパティ  ---------------------------------------------------------------
	/** 編集フラグ */
	public get isEdit(): boolean	{ return false; 	}
	// --------------------------------------------------------------------------

	// コンストラクタ  -----------------------------------------------------------
	constructor(props: IWprLiProps){
		super(props);
	}
	// --------------------------------------------------------------------------

	// override メソッド  --------------------------------------------------------
	/**
	 * 値取得
	 * @returns 値
	 */
	protected getValue(): any {
		return undefined;
	}

	/**
	 * 描画
	 */
	public onRender(): ReactNode {
		if (this.state.visibility === WprControlVisibility.COLLAPSED)
			return <></>;
		const props = this.getProps();
		const {name, view, className, children, ...other} = this.props;
		const state = this.getState(['style']);
		let li = null;
		if (this.state.visibility === WprControlVisibility.VISIBLE) {
			li = <li {...props} {...state} {...other}>{this.props.children}</li>;
		}
		else {
			li = <li hidden {...props} {...state} {...other}>{this.props.children}</li>;
		}
		return (
			<>
				{li}
			</>
		);
	}
	// --------------------------------------------------------------------------
}